import { appMessages as messages } from '../../../../../messages'
import { EXERCISE_LOG_SUMMARY_KEY } from '../../constants'
import createValidationElementUtil from '../../../../redux/utils/create-validation-element'
import { UNIT } from '../../../../../constant'

function weightImperial (value) {
  if (value < 0) {
    return createValidationElementUtil(
      EXERCISE_LOG_SUMMARY_KEY.ONE_REP_MAX, messages.minimum, {
        key: EXERCISE_LOG_SUMMARY_KEY.ONE_REP_MAX,
        min: 0
      }
    )
  }
  if (value > 1200) {
    return createValidationElementUtil(
      EXERCISE_LOG_SUMMARY_KEY.ONE_REP_MAX, messages.maximum, {
        key: EXERCISE_LOG_SUMMARY_KEY.ONE_REP_MAX,
        max: 1200
      }
    )
  }
  return true
}

function weightMetric (value) {
  if (value < 0) {
    return createValidationElementUtil(
      EXERCISE_LOG_SUMMARY_KEY.ONE_REP_MAX, messages.minimum, {
        key: EXERCISE_LOG_SUMMARY_KEY.ONE_REP_MAX,
        min: 0
      }
    )
  }
  if (value > 500) {
    return createValidationElementUtil(
      EXERCISE_LOG_SUMMARY_KEY.ONE_REP_MAX, messages.maximum, {
        key: EXERCISE_LOG_SUMMARY_KEY.ONE_REP_MAX,
        max: 500
      }
    )
  }
  return true
}

function oneRepMaxExerciseLogSummaryValidatorUtil (value, options) {
  const { weightUnit } = options
  if (typeof value === 'string') {
    value = parseFloat(value)
  }
  if (!weightUnit || weightUnit === UNIT.IMPERIAL) {
    return weightImperial(value)
  }
  return weightMetric(value)
}

export default oneRepMaxExerciseLogSummaryValidatorUtil
